import { useView } from '@10000/react'
import { Table } from './table'

export const UserTable = () => {
  const { users, teams } = useView('tenant')

  const columns = [
    { key: 'name', name: 'Name' },
    { key: 'email', name: 'Email' },
    { key: 'admin', name: 'Role' },
    { key: 'teams', name: 'Teams' },
    { key: 'onboard', name: 'Onboarded' },
    { key: 'passwordSet', name: 'Password set' }
  ]

  const rows = users.map(({ id, admin, email, name, onboard, passwordSet }) => ({
    name,
    email,
    admin: admin ? 'Admin' : 'Team leader',
    teams: teams.filter(x => x.leaders.some(y => y.id === id)).length,
    onboard: onboard ? 'Yes' : 'No',
    passwordSet: passwordSet ? 'Yes' : 'No'
  }))

  return (
    <Table
      title="Users"
      rows={rows}
      columns={columns}
      defaultSortColumn="name"
    />
  )
}